import React from 'react'
import PropTypes from 'prop-types'

/**
 * Renders an SVG icon component.
 * @constructor
 *
 * @param {Object} props - The component props.
 * @param {string|JSX.ElementType} props.icon - The icon source or component.
 * @param {string} [props.name] - The name of the icon.
 * @param {string} [props.className] - The CSS class name for the icon.
 * @param {string} [props.fill] - The fill color for the icon.
 * @param {string} [withContainer=true]
 * @param {number} [containerSize]
 * @param {string} [containerClassName]
 * @param {React.CSSProperties} [props.style] - The inline styles for the icon.
 */
export const SvgIcon = ({
  name,
  className,
  fill,
  icon,
  style,
  size,
  withContainer = false,
  containerSize,
  containerClassName,
  ...props
}) => {
  if (!icon) return null

  const IconComponent = (() => {
    const containerStyle = {
      width: size ? `${size}px` : undefined,
      height: size ? `${size}px` : undefined,
    }
    if (typeof icon === 'string')
      return (
        <img
          src={icon}
          alt={`${name} icon`}
          className={className}
          style={{ fill, ...containerStyle, ...style }}
          {...props}
        />
      )
    else if (typeof icon === 'object') {
      const IconComponent = icon
      return (
        <IconComponent
          className={className}
          style={{
            fill,
            position: 'relative',
            top: '1px',
            cursor: props?.onClick ? 'pointer' : undefined,
            ...containerStyle,
            ...style,
          }}
          {...props}
        />
      )
    }
  })()

  if (!withContainer) return IconComponent

  const containerStyle = {
    width: containerSize ? `${containerSize}px` : undefined,
    height: containerSize ? `${containerSize}px` : undefined,
  }

  return (
    <div className={containerClassName} style={containerStyle}>
      {IconComponent}
    </div>
  )
}

SvgIcon.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  fill: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
}
